export default "__VITE_ASSET__DeeCFjoQ__"